// extracted by mini-css-extract-plugin
export default {"alert":"NotificationItem_alert__mrI4u"};